<nb-card class="container" [nbSpinner]="loading">
  <nb-card-header class="row">
    <h3 class="col">{{"Block" | tenantWords}} Select</h3>
  </nb-card-header>
  <nb-card-body class="row container" style="height: 60vh;">
    <div class="col" style="height: 100%;">
      <nb-card style="height: 100%;">
        <nb-card-header>
          <div class="row">
            <div class="col">
              <h4>Farms</h4>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="row">
            <div class="col" style="overflow-y: scroll; max-height: 50vh;">
              <mat-list dense>
                  <mat-list-item *ngFor="let farm of this.farmSearchSelectedFarms">
                    <mat-checkbox [(ngModel)]="farm.checked"
                      (change)="onFarmSelect($event, farm)">
                      {{farm.name}}
                    </mat-checkbox>
                  </mat-list-item>
                </mat-list>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <!--- Block list!!! -->
    <div class="col" style="height: 100%;">
      <nb-card style="height: 100%;">
        <nb-card-header>
          <div class="row">
            <div class="col">
              <h4>{{"Block" | tenantWords}}</h4>
            </div>
          </div>
        </nb-card-header>
        <nb-card-body>
          <div class="row">
            <div class="col" style="overflow-y: scroll; max-height: 50vh;">
              <div class="row" *ngFor="let farm of this.farmSearchSelectedFarms">
                <div class="col" *ngIf="farm.checked">
                  <div class="row">
                    <h5 style="margin-left: 10px; margin-top: 15px;" class="col">
                      {{farm.name}}
                    </h5>
                  </div>
                  <div class="row">
                    <div class="col">
                      <mat-divider></mat-divider>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <mat-list dense>
                        <mat-list-item *ngFor="let block of farm.blocks">
                          <mat-checkbox [checked]="checkIfBlockIsSelected(block.id)"
                            (change)="onBlockSelect($event, block)">
                            {{block.name}} ({{block.varietyName}})
                          </mat-checkbox>
                        </mat-list-item>
                      </mat-list>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col" *ngIf="!this.farmSelected()">
                <h6>Please select a farm</h6>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-card-body>

  <nb-card-footer class="row" style="margin-top: 10px;">
    <div class="col-md-auto d-flex align-items-center">
      <button mat-raised-button color="primary" (click)="saveAndClose()">Save and
        Close</button>
    </div>
    <div class="col d-flex align-items-center justify-content-start">
        <a mat-button (click)="close()">Cancel</a>
    </div>
    <div class="col d-flex align-items-center justify-content-end">
      {{"Blocks" | tenantWords}} selected: {{selectedBlocks.length}}
    </div>
  </nb-card-footer>
</nb-card>